import React from "react";
import "./BankInfo.scss";
import validate from "../../../validations";
import { FormGroup, FormLabel } from "react-bootstrap";
import Input from "../../../assets/elements/formElements/adminInput/AdminInput";

export default function BankForm(props) {
  return (
    <div className="bank-form-main">
      <div>
        <FormGroup className="login-input-group">
          <FormLabel>Bank Name*</FormLabel>
          <Input
            type="text"
            name="bankName"
            onChange={props.handleChange}
            onBlur={props.handleBlur}
            value={props.values.bankName}
            placeholder="Enter Bank Name"
            className="customer-name-input"
          />
          {validate.displayError(props.touched, props.errors, "bankName")}
        </FormGroup>
        <FormGroup className="login-input-group">
          <FormLabel>Account Owner Name*</FormLabel>
          <Input
            type="text"
            name="ownerName"
            onChange={props.handleChange}
            onBlur={props.handleBlur}
            value={props.values.ownerName}
            placeholder="Enter Name"
            className="customer-name-input"
          />
          {validate.displayError(props.touched, props.errors, "ownerName")}
        </FormGroup>
        <FormGroup className="login-input-group">
  <FormLabel>Account Number*</FormLabel>
  <Input
    type="text"
    name="ownerAccount"
    onChange={(e) => {
      let value = e.target.value.replace(/\D/g, ""); // digits only
      if (value.length > 8) value = value.slice(0, 8); // max 8 digits
      props.handleChange({
        target: { name: "ownerAccount", value },
      });
    }}
    onBlur={(e) => {
      let value = e.target.value;
      // Auto-pad with leading zeros if <8 digits
      if (value.length < 8) {
        value = value.padStart(8, "0");
        props.handleChange({
          target: { name: "ownerAccount", value },
        });
      }
      props.handleBlur(e);
    }}
    value={props.values.ownerAccount}
    placeholder="Enter 8-digit Account Number"
    className="customer-name-input"
  />
  {validate.displayError(props.touched, props.errors, "ownerAccount")}
</FormGroup>
        <FormGroup className="login-input-group">
          <FormLabel>Confirm Account Number*</FormLabel>
          <Input
            type="text"
            name="ownerCAccount"
            onChange={props.handleChange}
            onBlur={props.handleBlur}
            value={props.values.ownerCAccount}
            placeholder="Enter Confirm account Number"
            className="customer-name-input"
          />
          {validate.displayError(props.touched, props.errors, "ownerCAccount")}
        </FormGroup>
        <FormGroup className="login-input-group">
  <FormLabel>Sort Code*</FormLabel>
  <Input
    type="text"
    name="sortCode"
    onChange={(e) => {
      let value = e.target.value.replace(/\D/g, ""); // keep digits only
      if (value.length > 6) value = value.slice(0, 6);
      // format as XX-XX-XX
      const formatted = value.replace(/(\d{2})(?=\d)/g, "$1-").replace(/-$/, "");
      props.handleChange({
        target: { name: "sortCode", value: formatted },
      });
    }}
    onBlur={props.handleBlur}
    value={props.values.sortCode}
    placeholder="e.g. 20-23-62"
    className="customer-name-input"
  />
  {validate.displayError(props.touched, props.errors, "sortCode")}
</FormGroup>

        <FormGroup className="login-input-group">
          <FormLabel>Bank Address*</FormLabel>
          <Input
            type="text"
            name="bankAddress"
            onChange={props.handleChange}
            onBlur={props.handleBlur}
            value={props.values.bankAddress}
            placeholder="Enter Address"
            className="customer-name-input"
          />
          {validate.displayError(props.touched, props.errors, "bankAddress")}
        </FormGroup>
      </div>
    </div>
  );
}
